module.exports = __webpack_public_path__ + "img/ÜbungsdiensteSep21.6444ec07.jpg";